export default __webpack_public_path__ + "static/about1-d4c6a00d2f4614a9fad010461283c385.png";